<template>
  <article class="box">
    <v-heading-section :logo="logo">
      <template #heading-title>
        <slot name="box-title"></slot>
      </template>
      <template #heading-description>
        <slot name="box-description"></slot>
      </template>
    </v-heading-section>
    <p class="paragraph">
      <slot name="box-text"></slot>
    </p>
  </article>
</template>

<script>
import VHeadingSection from '@/components/atomic/VHeadingSection.vue';

export default {
  name: 'VTextBox',
  components: {
    VHeadingSection,
  },
  props: {
    logo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.box {
  min-width: 250px;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .paragraph {
    font-family: var(--ff-roboto-sans);
    color: hsl(var(--clr-primary-100));
    line-height: 1.5;
  }
}
</style>
